/**
 * "Otros servicios" de la home (wisest-labs/02 §3.4, D-4).
 *
 * Precios: NUNCA hardcodeados acá. Se calculan con getSessionPrice
 * (src/lib/utils/pricing.ts, misma fuente que el wizard — docs/PRECIOS.md).
 * La promo online de octubre (FUNC-105) entra y sale sola por la fecha.
 *
 * Familiar NO va (deshabilitada, FUNC-131). Individual y pareja NO van: ya
 * están en las cards de Precios (sin duplicar). Sexología: $36.000 definido por
 * el usuario 2026-10-21, NO está en la matriz de cobro ni es tipo agendable en
 * /agendar → precio fijo acá (docs/PRECIOS.md M12) y CTA solo WhatsApp.
 */
import { getSessionPrice, SessionPriceInput } from '../lib/utils/pricing';

export interface HomeService {
  id: 'online' | 'sexologia' | 'domicilio';
  name: string;
  forWhom: string;
  duration: string;
  modality: string;
  icon: string;
  /** Combinación para getSessionPrice; null = usa fixedPrice. */
  priceInput: Omit<SessionPriceInput, 'fechaHora'> | null;
  /** Precio fijo cuando getSessionPrice no cubre el servicio (ver docs/PRECIOS.md M12). */
  fixedPrice?: number;
  priceNote?: string;
  /** true = precio fijo (sin "desde"). */
  flatPrice?: boolean;
  /** false → no se ofrece "Agendar" (el wizard no tiene ese servicio). */
  bookable: boolean;
  whatsappText: string;
}

export const homeServices: HomeService[] = [
  {
    id: 'online',
    name: 'Psicólogo online',
    forWhom: 'Atención por videollamada desde cualquier lugar de Chile, con la misma calidad que en consulta.',
    duration: '45-50 min',
    modality: 'Online',
    icon: 'fa-video',
    priceInput: { tipo: 'individual', duracion: 45, modalidad: 'online', metodo: 'transferencia' },
    priceNote: 'sesión individual online',
    bookable: true,
    whatsappText: 'Hola, quisiera información sobre la atención psicológica online',
  },
  {
    id: 'sexologia',
    name: 'Sexología clínica',
    forWhom: 'Dificultades en la vida sexual, de forma individual o en pareja, en un espacio sin juicios.',
    duration: 'Por sesión',
    modality: 'Presencial u online',
    icon: 'fa-heart',
    priceInput: null,
    fixedPrice: 36000,
    flatPrice: true,
    bookable: false,
    whatsappText: 'Hola, quisiera información sobre sexología clínica',
  },
  {
    id: 'domicilio',
    name: 'Pareja a domicilio',
    forWhom: 'Terapia de pareja en la comodidad de tu casa, en todo Santiago.',
    duration: '90 min',
    modality: 'A domicilio',
    icon: 'fa-house',
    priceInput: { tipo: 'pareja', duracion: 90, modalidad: 'domicilio', metodo: 'transferencia' },
    priceNote: 'valor fijo, cualquier medio de pago',
    flatPrice: true,
    bookable: true,
    whatsappText: 'Hola, quisiera información sobre terapia de pareja a domicilio',
  },
];

/** Fecha de hoy en Santiago (YYYY-MM-DD) para que la promo online aplique sola. */
const todaySantiago = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Santiago' });

export function getServicePrice(s: HomeService): number | null {
  return s.priceInput ? getSessionPrice({ ...s.priceInput, fechaHora: todaySantiago() }) : s.fixedPrice ?? null;
}
